import {
  SET_AUTH_PROGRESS,
  SET_USER,
  START_LOADING,
  SET_AD_GROUPS,
  STOP_LOADING,
  SET_USERS_LOADING,
  SET_USERS,
  SET_CURRENT_USER_ADP_PERMISSION,
  UPDATE_CURRENT_USER_ADP_PERMISSION_DATA_LOADED_STATE,
  SET_CONFIGURED_USERS,
  SET_CONFIGURED_USERS_LOADING,
  SET_USERS_PERMISSIONS,
} from './mutation-types';

export default {
  [SET_AUTH_PROGRESS]: (state, progress) => state.authProgress = progress,
  [START_LOADING]: (state, objectKey) => state[objectKey].loading = true,
  [STOP_LOADING]: (state, objectKey) => state[objectKey].loading = false,
  [SET_USER]: (state, user) => state.user = user,
  [SET_AD_GROUPS]: (state, groups) => state.adGroups.data = groups,
  [SET_USERS_LOADING](state, loading) {
    state.users.loading = loading;
  },
  [SET_USERS](state, users) {
    state.users.data = users;
  },
  [SET_CURRENT_USER_ADP_PERMISSION](state, data) {
    state.currentUserAdpPermission.data = data;
  },
  [UPDATE_CURRENT_USER_ADP_PERMISSION_DATA_LOADED_STATE](state) {
    state.currentUserAdpPermission.loaded = true;
  },
  updateSingleUser(state, user) {
    state.users.data = state.users.data.map(u => {
      if (u.id === user.id) {
        return {
          ...u,
          ...user,
        };
      }
      return u;
    });
  },
  // updateSingleGroup(state, group) {
  //   state.groups.data = state.groups.data.map(u => {
  //     if (u.Id == group.Id) {
  //       return {
  //         ...u,
  //         ...group
  //       }
  //     }
  //     return u;
  //   })
  // }

  [SET_CONFIGURED_USERS](state, payload) {
    state.configuredUsers.data = payload;
  },
  [SET_CONFIGURED_USERS_LOADING](state, payload) {
    state.configuredUsers.loading = payload;
  },
  [SET_USERS_PERMISSIONS](state, payload){
    const map = {};
    payload.forEach(el => map[el.userGuid] = el);
    state.usersPermissions = map;
  },
};
